import {
  FeedbackDetailsPredictionsContent,
  FeedbackDetailsPredictionsHeader,
} from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsRightPanel';
import { SetSelectedLabels } from '@modules/feedback/types';
import { Paper, Stack } from '@mui/material';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';

interface FeedbackPredictionsGroupProps {
  feedback: Feedback;
  setSelectedLabels: SetSelectedLabels;
  selectedLabels: FeedbackLabel[];
}

export const FeedbackDetailsPredictions = ({
  feedback,
  setSelectedLabels,
  selectedLabels,
}: FeedbackPredictionsGroupProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        py: 2,
        px: 3,
        borderRadius: 2,
      }}
    >
      <Stack>
        <FeedbackDetailsPredictionsHeader feedback={feedback} />
        <FeedbackDetailsPredictionsContent
          feedback={feedback}
          selectedLabels={selectedLabels}
          setSelectedLabels={setSelectedLabels}
        />
      </Stack>
    </Paper>
  );
};
